<template>
  <div>
    <div class="card card-custom gutter-b" style="box-shadow: none">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <li class="nav-item">
            <a
              class="nav-link active usuario-cadastro-tab"
              data-tab="0"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Cadastro
            </a>
          </li>
        </ul>
      </div>
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div class="card-body">
          <b-alert
            v-if="userLimitError"
            show
            variant="warning"
            class="user-limit-alert"
          >
            <div>
              <strong>Limite de usuários atingido.</strong>
              <p class="mb-0">
                Sua empresa já atingiu o limite de usuários disponíveis no
                plano. Para cadastrar mais usuários, contrate Usuários Extras no
                Marketplace.
              </p>
            </div>
            <button
              type="button"
              class="btn btn-primary font-weight-bold"
              @click="goToMarketplace"
            >
              Ir para Marketplace
            </button>
          </b-alert>

          <b-tabs class="hide-tabs" v-model="tabIndex">
            <b-tab active>
              <b-row class="usuario-form-layout">
                <b-col lg="6" md="6">
                  <div class="usuario-fields">
                    <b-form-group id="nome" label-for="nome" label="Nome">
                      <b-form-input
                        v-model="form.nome"
                        :state="validateState('nome')"
                        autofocus
                      >
                      </b-form-input>
                    </b-form-group>
                    <b-form-group
                      id="usuario"
                      label-for="usuario"
                      label="E-mail"
                    >
                      <b-form-input
                        type="email"
                        v-model="$v.form.usuario.$model"
                        :state="validateState('usuario')"
                      >
                      </b-form-input>
                    </b-form-group>
                    <b-form-group label="Vendedor" label-for="vendedor">
                      <VueSelect
                        ref="buscaVendedor"
                        :filterable="false"
                        @input="setVendedor"
                        :options="vendedores"
                        v-model="form.vendedor"
                        @search="onSearchVendedor"
                      >
                        <template slot="no-options">
                          Informe o nome do vendedor
                        </template>
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            {{ option.nome }}
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ option.nome }}
                          </div>
                        </template>
                      </VueSelect>
                    </b-form-group>
                    <b-form-group
                      v-if="isCreate"
                      id="password"
                      label-for="password"
                      label="Senha"
                    >
                      <b-form-input
                        type="password"
                        autocomplete="new-password"
                        maxlength="72"
                        v-model="$v.form.password.$model"
                        :state="validateState('password')"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback>
                        A senha deve ter entre 4 e 72 caracteres.
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                      v-if="isCreate"
                      id="password_confirmation"
                      label-for="password_confirmation"
                      label="Confirmar senha"
                    >
                      <b-form-input
                        type="password"
                        autocomplete="new-password"
                        maxlength="72"
                        v-model="$v.form.password_confirmation.$model"
                        :state="validateState('password_confirmation')"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback>
                        A confirmação deve ser igual à senha.
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group id="status" label-for="status" label="Ativo">
                      <span class="switch switch-icon">
                        <label>
                          <input
                            type="checkbox"
                            :value="true"
                            @change="setAtivo"
                            :checked="form.status == 'A'"
                          />
                          <span></span>
                        </label>
                      </span>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col lg="6" md="6">
                  <b-form-group
                    label="Atribuir perfil de recurso"
                    label-for="perfil-recurso"
                  >
                    <b-input-group>
                      <b-form-select
                        id="perfil-recurso"
                        v-model="selectedProfileId"
                        :options="profileOptions"
                        @change="onProfileChange"
                      />
                      <b-input-group-append>
                        <b-button
                          variant="primary"
                          class="font-weight-bold"
                          @click="openProfileModal"
                        >
                          Adicionar
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <div class="form-user-access">
                    <label class="mb-5 mt-0">
                      Selecione os recursos que o usuário poderá acessar
                    </label>
                    <div
                      v-for="(r, index) in recursos"
                      :key="'recurso' + index"
                      class="w-100"
                    >
                      <b-row align-v="center">
                        <b-col md="auto">
                          <h3>
                            <b-button
                              @click="
                                collapseToggle(
                                  resourceCollapseId('usuario', r, index)
                                )
                              "
                              >+</b-button
                            >
                          </h3>
                        </b-col>
                        <b-col>
                          <h3>{{ r.name }}</h3>
                        </b-col>
                        <b-col md="auto">
                          <span class="switch switch-icon">
                            <label v-b-tooltip.hover.right="'Negar/Permitir'">
                              <input
                                v-model="r.checked"
                                type="checkbox"
                                :value="true"
                                :checked="r.checked"
                                :disabled="isProfileSelected"
                                @change="checkMenu(r, isProfileSelected)"
                              />
                              <span></span>
                            </label>
                          </span>
                        </b-col>
                      </b-row>
                      <b-collapse
                        :id="resourceCollapseId('usuario', r, index)"
                        class="mb-5"
                      >
                        <div
                          v-for="(sub, key) in r.submenus"
                          :key="'sub' + key"
                          class="text-center ml-20 w-100"
                          align-v="center"
                        >
                          <div class="recursos-list">
                            <h7>{{ sub.name }}</h7>
                            <span
                              class="switch switch-icon"
                              v-b-tooltip.hover.right="'Negar/Permitir'"
                            >
                              <label>
                                <input
                                  v-model="
                                    recursos[index].submenus[key].checked
                                  "
                                  type="checkbox"
                                  :value="true"
                                  :disabled="isProfileSelected"
                                  :checked="
                                    recursos[index].submenus[key].checked
                                  "
                                />
                                <span></span>
                              </label>
                            </span>
                          </div>
                        </div>
                      </b-collapse>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>

        <div class="card-footer">
          <div class="row">
            <div class="col-lg-12" style="text-align: center">
              <button
                type="submit"
                ref="submit_usuario_novo"
                class="btn btn-primary font-weight-bold"
              >
                Salvar
              </button>
              <router-link
                class="btn btn-clean font-weight-bold"
                :to="{
                  name: 'usuariosLista',
                }"
              >
                Cancelar
              </router-link>
            </div>
          </div>
        </div>
      </b-form>
    </div>
    <b-modal
      v-model="profileModalVisible"
      size="xl"
      title="Perfis de recurso"
      hide-footer
      @hidden="resetProfileForm"
    >
      <b-tabs v-model="profileTabIndex">
        <b-tab :title="profileFormTitle">
          <b-form @submit.stop.prevent="saveProfileResource">
            <b-form-group
              id="perfil-recurso-nome"
              label-for="perfil-recurso-nome"
              label="Nome"
            >
              <b-form-input
                id="perfil-recurso-nome"
                v-model="profileForm.nome"
                maxlength="100"
              />
            </b-form-group>
            <div class="form-user-access perfil-recurso-access">
              <label class="mb-5 mt-0">
                Selecione os recursos que este perfil poderá acessar
              </label>
              <div
                v-for="(r, index) in profileForm.recursos"
                :key="'perfil-recurso' + index"
                class="w-100"
              >
                <b-row align-v="center">
                  <b-col md="auto">
                    <h3>
                      <b-button
                        @click="
                          collapseToggle(resourceCollapseId('perfil', r, index))
                        "
                        >+</b-button
                      >
                    </h3>
                  </b-col>
                  <b-col>
                    <h3>{{ r.name }}</h3>
                  </b-col>
                  <b-col md="auto">
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Negar/Permitir'">
                        <input
                          v-model="r.checked"
                          type="checkbox"
                          :value="true"
                          :checked="r.checked"
                          @change="checkMenu(r)"
                        />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </b-row>
                <b-collapse
                  :id="resourceCollapseId('perfil', r, index)"
                  class="mb-5"
                >
                  <div
                    v-for="(sub, key) in r.submenus"
                    :key="'perfil-sub' + key"
                    class="text-center ml-20 w-100"
                    align-v="center"
                  >
                    <div class="recursos-list">
                      <h7>{{ sub.name }}</h7>
                      <span
                        class="switch switch-icon"
                        v-b-tooltip.hover.right="'Negar/Permitir'"
                      >
                        <label>
                          <input
                            v-model="
                              profileForm.recursos[index].submenus[key].checked
                            "
                            type="checkbox"
                            :value="true"
                            :checked="
                              profileForm.recursos[index].submenus[key].checked
                            "
                          />
                          <span></span>
                        </label>
                      </span>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <div class="text-center mt-6">
              <b-button
                type="submit"
                variant="primary"
                class="font-weight-bold"
                :disabled="profileSaving"
              >
                Salvar perfil
              </b-button>
              <b-button
                v-if="profileForm.id_usuario_perfil_recurso"
                variant="clean"
                class="font-weight-bold"
                @click="resetProfileForm"
              >
                Cancelar edição
              </b-button>
            </div>
          </b-form>
        </b-tab>
        <b-tab title="Gerenciar">
          <div v-if="resourceProfiles.length === 0" class="text-muted">
            Nenhum perfil cadastrado.
          </div>
          <div v-else class="table-responsive">
            <table class="table table-head-custom table-vertical-center">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th class="text-right">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="profile in resourceProfiles"
                  :key="'profile-row' + profile.id_usuario_perfil_recurso"
                >
                  <td class="font-weight-bolder">{{ profile.nome }}</td>
                  <td class="text-right">
                    <b-button
                      size="sm"
                      variant="info"
                      class="btn-icon mr-2"
                      v-b-tooltip="'Editar'"
                      @click="editProfileResource(profile)"
                    >
                      <Pencil :size="16" title="Editar" />
                    </b-button>
                    <b-button
                      size="sm"
                      variant="danger"
                      class="btn-icon"
                      v-b-tooltip="'Excluir'"
                      @click="deleteProfileResource(profile)"
                    >
                      <TrashCanIcon :size="16" />
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import JwtService from "@/core/services/jwt.service";
import { SistemaMixin } from "@/modules/Application";
import UsuariosData, { UsuariosDataRequired } from "./UsuariosData";
import {
  maxLength,
  minLength,
  required,
  sameAs,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import _ from "lodash";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";

export default {
  name: "app-usuario-form",
  components: {
    VueSelect,
    Pencil,
    TrashCanIcon,
  },
  props: {
    url: {
      type: String,
    },
    usuario: {
      type: UsuariosData,
      required: true,
    },
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      tabIndex: 0,
      form: {},
      recursos: [],
      vendedores: [],
      resourceProfiles: [],
      selectedProfileId: null,
      lastSelectedProfileId: null,
      manualRecursosBackup: null,
      profileModalVisible: false,
      profileTabIndex: 0,
      profileSaving: false,
      userLimitError: null,
      profileForm: {
        id_usuario_perfil_recurso: null,
        nome: "",
        recursos: [],
      },
    };
  },
  validations() {
    const form = {
      ...UsuariosDataRequired,
    };

    if (this.isCreate) {
      form.password = {
        required,
        minLength: minLength(4),
        maxLength: maxLength(72),
      };
      form.password_confirmation = {
        required,
        sameAsPassword: sameAs("password"),
      };
    }

    return {
      form,
    };
  },
  computed: {
    ...mapGetters(["itsblocked"]),
    isCreate() {
      return this.url === "/usuario/create";
    },
    isProfileSelected() {
      return this.hasProfileSelected(this.selectedProfileId);
    },
    profileOptions() {
      return [
        {
          value: null,
          text: "Ajuste manual",
        },
        ...this.resourceProfiles.map((profile) => ({
          value: profile.id_usuario_perfil_recurso,
          text: profile.nome,
        })),
      ];
    },
    profileFormTitle() {
      return this.profileForm.id_usuario_perfil_recurso ? "Editar" : "Criar";
    },
    isParceiroSession() {
      return (
        JwtService.getParceiro() === "true" || JwtService.getParceiro() === true
      );
    },
    shouldRequestAdminPassword() {
      return this.isCreate && !this.isParceiroSession;
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
  watch: {
    usuario(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
        this.recursos = this.cloneRecursos(newValue.recursos);
        this.manualRecursosBackup = this.cloneRecursos(newValue.recursos);
        this.selectedProfileId = null;
        this.lastSelectedProfileId = null;
      }
    },
  },
  methods: {
    setAtivo() {
      this.form.status = this.form.status == "A" ? "I" : "A";
    },
    cloneRecursos(recursos) {
      return JSON.parse(JSON.stringify(recursos || []));
    },
    hasProfileSelected(profileId) {
      return profileId !== null && profileId !== "";
    },
    checkMenu(menu, disabled = false) {
      if (disabled) {
        return;
      }

      menu.submenus = menu.submenus.map((submenu) => ({
        ...submenu,
        checked: menu.checked,
      }));
    },
    collapseToggle(id) {
      this.$root.$emit("bv::toggle::collapse", id);
    },
    resourceCollapseId(prefix, recurso, index) {
      const name = (recurso.name || "")
        .toString()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-");

      return `${prefix}-recurso-${index}-${name}`;
    },
    async getDataInit() {
      this.form = new UsuariosData({});
      this.recursos = await this.getMenus();
      this.manualRecursosBackup = this.cloneRecursos(this.recursos);
      this.profileForm.recursos = this.cloneRecursos(this.recursos);
      await this.getResourceProfiles();
      if (this.usuario.id_usuario) {
        this.form = await this.usuario;
      }
    },
    async getResourceProfiles() {
      try {
        const { data } = await this.$http.post("/usuario/perfil-recurso");
        this.resourceProfiles = data;
      } catch (error) {
        this.resourceProfiles = [];
      }
    },
    getProfileById(profileId) {
      return this.resourceProfiles.find(
        (profile) =>
          String(profile.id_usuario_perfil_recurso) === String(profileId)
      );
    },
    onProfileChange(profileId) {
      if (!this.hasProfileSelected(profileId)) {
        if (this.manualRecursosBackup) {
          this.recursos = this.cloneRecursos(this.manualRecursosBackup);
        }

        this.lastSelectedProfileId = null;
        return;
      }

      if (!this.hasProfileSelected(this.lastSelectedProfileId)) {
        this.manualRecursosBackup = this.cloneRecursos(this.recursos);
      }

      const profile = this.getProfileById(profileId);

      if (profile) {
        this.recursos = this.cloneRecursos(profile.recursos);
      }

      this.lastSelectedProfileId = profileId;
    },
    openProfileModal() {
      if (!this.profileForm.id_usuario_perfil_recurso) {
        this.profileForm.recursos = this.cloneRecursos(this.recursos);
      }

      this.profileModalVisible = true;
    },
    resetProfileForm() {
      this.profileForm = {
        id_usuario_perfil_recurso: null,
        nome: "",
        recursos: this.cloneRecursos(
          this.manualRecursosBackup || this.recursos
        ),
      };
      this.profileTabIndex = 0;
    },
    async saveProfileResource() {
      const nome = (this.profileForm.nome || "").trim();

      if (!nome) {
        this.$toast.error("Informe o nome do perfil de recurso.");
        return;
      }

      this.profileSaving = true;

      try {
        const isUpdate = !!this.profileForm.id_usuario_perfil_recurso;
        const url = isUpdate
          ? "/usuario/perfil-recurso/update"
          : "/usuario/perfil-recurso/create";
        const payload = {
          id_usuario_perfil_recurso: this.profileForm.id_usuario_perfil_recurso,
          nome,
          recursos: this.cloneRecursos(this.profileForm.recursos),
        };

        const { data } = await this.$http.post(url, payload);

        await this.getResourceProfiles();

        if (!this.hasProfileSelected(this.lastSelectedProfileId)) {
          this.manualRecursosBackup = this.cloneRecursos(this.recursos);
        }

        this.selectedProfileId = data.id_usuario_perfil_recurso;
        this.lastSelectedProfileId = data.id_usuario_perfil_recurso;
        this.recursos = this.cloneRecursos(data.recursos);
        this.$toast.success("Perfil de recurso salvo!");
        this.resetProfileForm();
      } catch (error) {
        this.$toast.error("Não foi possível salvar o perfil de recurso.");
      } finally {
        this.profileSaving = false;
      }
    },
    editProfileResource(profile) {
      this.profileForm = {
        id_usuario_perfil_recurso: profile.id_usuario_perfil_recurso,
        nome: profile.nome,
        recursos: this.cloneRecursos(profile.recursos),
      };
      this.profileTabIndex = 0;
    },
    async deleteProfileResource(profile) {
      const result = await this.$swal.fire({
        icon: "warning",
        title: "Excluir o perfil " + profile.nome + "?",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        confirmButtonColor: "#f64e60",
      });

      if (!result.isConfirmed) {
        return;
      }

      await this.$http.post("/usuario/perfil-recurso/delete", {
        id_usuario_perfil_recurso: profile.id_usuario_perfil_recurso,
      });

      if (
        String(this.selectedProfileId) ===
        String(profile.id_usuario_perfil_recurso)
      ) {
        this.selectedProfileId = null;
        this.lastSelectedProfileId = null;
        this.recursos = this.cloneRecursos(this.manualRecursosBackup);
      }

      await this.getResourceProfiles();
      this.resetProfileForm();
      this.$toast.success("Perfil de recurso excluído!");
    },
    validateState(name) {
      if (!this.$v.form[name]) {
        return null;
      }
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async requestAdminPassword() {
      const result = await this.$swal.fire({
        title: "Confirme a senha do administrador",
        showCancelButton: true,
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        input: "password",
        inputAttributes: {
          autocomplete: "current-password",
        },
        preConfirm: (adminPassword) => {
          if (!adminPassword) {
            this.$swal.showValidationMessage(
              "Informe a senha do administrador."
            );
            return false;
          }

          return adminPassword;
        },
      });

      if (!result.isConfirmed) {
        return null;
      }

      return result.value;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_usuario_novo"];

      try {
        this.userLimitError = null;
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        if (this.recursos) {
          this.form.recursos = this.recursos;
        }

        const payload = {
          ...this.form,
        };

        if (!this.isCreate) {
          delete payload.password;
          delete payload.password_confirmation;
        }

        if (this.shouldRequestAdminPassword) {
          const adminPassword = await this.requestAdminPassword();

          if (!adminPassword) {
            return;
          }

          payload.admin_password = adminPassword;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        await this.$http.post(this.url, payload);

        this.$router.push({ name: "usuariosLista" });
      } catch (error) {
        if (this.isUserLimitError(error)) {
          this.userLimitError = error.response?.data || {};
          this.$toast.warning("Limite de usuários atingido.");
        }

        if (submitButton) {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          submitButton.removeAttribute("disabled", "");
        }
      }
    },
    isUserLimitError(error) {
      const payload = error?.response?.data || {};
      const message = this.normalizeText(payload.message || payload.msg);
      const featureCode = String(payload.feature_code || "").toUpperCase();

      return (
        featureCode === "PLG_USUARIOS_EXTRA" ||
        (message.includes("limite") &&
          message.includes("usuario") &&
          message.includes("marketplace"))
      );
    },
    normalizeText(value) {
      return String(value || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    goToMarketplace() {
      this.$router.push({ name: "apps" });
    },
    onSearchVendedor(search, loading) {
      if (search.length) {
        loading(true);
        this.searchVendedor(loading, search, this);
      }
    },
    searchVendedor: _.debounce(async (loading, search, vm) => {
      vm.vendedores = await vm.getVendedorByNome(search);
      if (loading) loading(false);
    }, 350),
    setVendedor(vendedor) {
      this.form.id_vendedor = vendedor.id_vendedor;
    },
  },
};
</script>

<style>
.vs__dropdown-toggle {
  border: 2px solid #dedede;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 6px;
  outline: none;
  min-height: 44px;
}
.usuario-form-layout {
  align-items: flex-start;
}
.usuario-cadastro-tab {
  font-size: 1.25rem;
  line-height: 1.4;
}
.usuario-fields {
  max-width: 520px;
}
.usuario-fields .form-group,
.usuario-fields .form-control,
.usuario-fields .v-select {
  width: 100%;
}
.usuario-fields .form-control {
  height: 44px;
}
.user-limit-alert {
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
}
.form-user-access {
  display: flex;
  flex-direction: column;
  margin: 0;
  width: 100%;
  border: 2px solid #dedede;
  border-radius: 8px;
  padding: 1rem;
}
.perfil-recurso-access {
  max-height: 55vh;
  overflow-y: auto;
}
.recursos-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 1rem;
}
@media (max-width: 767px) {
  .user-limit-alert {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
